<template>
        <div class="Flex Flex--d-c PageWrapper">
            <div class="FlexItem childView">
                <div class="FlexItem">
                    <div class="containerCls">
                        <div :class="{'MessageContainer':true,'clearMarginCls':!isInputShow}">
                            <TopView :durationNum="globalDuration" @on-set-duration="setGlobalDuration"
                                     @on-ask="onPoke" :questionTips="questionTips" :guideTips="guideTips"/>
                            <div :class="['PullToRefresh',device=='ios'?'iosMinHeight':''] ">
                                <div :class="{'PullToRefresh-inner':true,'tourPaddingBottom':isTourShow,'inputPaddingBottom':isInputShow}" >
                                    <div class="PullToRefresh-content">
                                        <div class="contentBox chatting-content" ref="chatMain" id="chatMain">
                                            <slot></slot>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <RelateReplies :list="toastList" :currList="toastCurrList" :show="!!toastList.length&&isToast&&!isTourShow"
                                       @on-ask="onRateAsk" v-if="!isOpenChat"/>
<!--                        <transition name="fadeInput">-->
<!--                            <div :class="['questionBox', 'questionPadding', 'questionRadius','padByDevice']" id="tourBox" v-show="isTourShow">-->
<!--                                <SelectTags :list="tagsList"/>-->
<!--                                <SelectTour :list="selectList" :show="false" @on-ask="onSelectToast" />-->
<!--                            </div>-->
<!--                        </transition>-->

                        <transition name="fadeInput">
                            <div :class="['questionBox', 'questionPadding', 'questionRadius','padByDevice']" id="questionBox" v-show="isInputShow">
                                <QuickReplies :list="noticeList" :show="!!toastList.length" @on-ask="onQuickAsk"
                                              v-if="!isOpenChat && !isTourShow"/>
                                <QuickReplies :list="selectTourList" :show="!isTourShow" @on-ask="onQuickAsk"
                                              v-if="isTourShow" color="scrollTourTags"/>
                                <div :class="['ComposerPC', 'isCompact']">
<!--                                    修改input的限制字数-->
                                    <input id="inputValue" ref="searchInput" type="text" placeholder="在这里输入提问内容哦～"
                                           v-model.trim="inputValue"
                                           class="inputCls"
                                           v-on:input="onRate" maxlength="1024" @blur="onBlur"  @keyup.enter="onAsk"/>
                                    <div class="button">
                                        <img src="../assets/img/send.png" alt="发送" class="sendImg" @click="onAsk">
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </div>

</template>
<script>
    import {mapState, mapActions, mapMutations} from "vuex";
    import {parseData, objBlurFun} from "@/utils/utils";
    import {TopView, QuickReplies, RelateReplies} from "./View/index";
    import SelectTags from './Use/tags'
    import SelectTour from './Use/select-tour'

    export default {
        name: "PageWrapper",
        components: {TopView, QuickReplies, RelateReplies,SelectTags,SelectTour},
        props: {},
        data() {
            return {
                inputValue: "",
                isToast: false,
                toastCurrList: []
            };
        },
        watch: {},
        computed: {
            ...mapState(["toastList", "noticeList", "globalDuration", "device", "isOpenChat", "readNewsId", "isInputShow","questionTips","guideTips","isTourShow","selectList","tagsList"]),
            selectTourList(){
                 const {selectList,tourSelectType}=this.$store.state
                console.info('tourSelectType',tourSelectType)
                 return tourSelectType?selectList.filter((it)=>{return it.value==tourSelectType})[0].children:[]
            }

        },
        methods: {
            ...mapMutations([
                "contactDisData", "setHomeData", "setToastList", "setLinkSrc", "setGlobalDuration", "setChatLoading", "setClearTimer", "setInputShow", "setMaskShowStatus","setTourSelectData","setToastShow","setToastContent"
            ]),
            ...mapActions(["fetchRelate", "fetchHome", "fetchNotice", "discussNews", "queryPoke","getTourSelectData","queryTourism"]),

            onAsk() {
                let that = this;
                this.isToast = false;
                this.service.pageScrollTo();
                this.setToastList([]);

                if (this.inputValue !== "") {
                    this.onRequest(this.inputValue, this.inputValue,false);
                } else {
                    return;
                }
            },

            onRequest(name, value,hasClearTimer) {
                let that = this;

                this.setChatLoading(true);
                this.setGlobalDuration(0);
                this.setClearTimer(true);
                that.contactDisData([{content: {right: true, tips: name}}]);
                that.inputValue = "";
                if (this.isOpenChat) {
                    that.discussNews({payload: {question: value, newsId: this.readNewsId}}).then((res) => {
                        if (res.length) {
                            that.setChatLoading(false);
                        }
                        cio.track(7, "click", 'send_msg',{msg: value});

                        setTimeout(() => {
                            that.service.pageScrollTo();
                        }, 100);
                    });
                } else {
                    that.fetchHome({payload: {question: value,hasClearTimer}}).then((res) => {
                        if (res.length) {
                            that.setChatLoading(false);
                        }
                        cio.track(7, "click", 'send_msg',{msg: value});
                        setTimeout(() => {
                            that.service.pageScrollTo();
                        }, 100);
                    });
                }

            },


            onRateAsk(value) {
                this.isToast = false;
                this.setToastList([]);
                cio.track(4,'click', "foot_shortcut",{shortcutName:value});
                // cio.track(5,'click', "click_scene",{sceneName:value});
                this.onRequest(value, value,false);
            },

            onRate() {
                let that = this;
                if(this.inputValue!==''){
                    that.setClearTimer(true);
                    that.isToast = true;
                    that.fetchRelate({payload: {question: this.inputValue}}).then((res) => {
                        that.toastCurrList = parseData(res, this.inputValue);
                    });
                }else {
                    that.setClearTimer(false);
                    that.toastCurrList=[]
                    that.isToast=false
                }

            },
            onBlur() {
                console.info("onBlur");
                let that = this;
                setTimeout(() => {
                    that.setMaskShowStatus(false);
                }, 0);
            },

            onQuickAsk(name, value) {
                this.onRequest(name, value,true);
            },

            onPoke(name, value) {
                let that = this;
                this.setChatLoading(true);
                this.setGlobalDuration(0);
                this.setClearTimer(true);
                that.contactDisData([{content: {right: true, tips: name}}]);

                that.queryPoke().then((res) => {
                    if (res.length) {
                        that.setChatLoading(false);
                    }
                    setTimeout(() => {
                        that.service.pageScrollTo();
                    }, 100);
                });
            },

            onSelectToast(name, value, id,toastType,children,selectType){
                let that = this;
                this.setToastShow(true)
                this.setToastContent({
                    toastType: toastType,
                    selectType,
                    list: {name:name, content:children}
                })
                this.setTourSelectData(children)

            },
        },
        mounted() {


        }
    };
</script>
<style lang="less" scoped>
    .PageWrapper {

        overflow: hidden;
        width: 100%;
        height: 100%;
        /*margin: 0 auto;*/
        /*height: 9rem;*/
        /*background: #fff;*/
        /*position: absolute;*/
        /*bottom: 0;*/
        /*border-radius: .8rem 0 0 0;*/

        .fadeInput-enter-active,
        .fadeInput-leave-active {
            transition: opacity 0.5s;
        }

        .fadeInput-enter,
        .fadeInput-leave-to {
            opacity: 0;
        }

        .containerCls {
            display: -ms-flexbox;
            display: flex;
            -ms-flex-direction: column;
            flex-direction: column;
            height: 100%;

        }

        .childView {
            display: flex;
        }

        .contentBox {
            overflow-y: scroll;

        }

        .tourPaddingBottom{
            padding-bottom: 3rem;
        }
        .inputPaddingBottom{
            padding-bottom: 4rem;
        }

        .PullToRefresh-inner {

            overflow: hidden;
            /*min-height:100%;*/
        }

        .PullToRefresh {
            height: 100%;
            overflow-y: scroll;
            -webkit-overflow-scrolling: touch;
            padding-bottom: 0;
        }

        .iosMinHeight {
            min-height: 8rem;
        }


        .MessageContainer {
            position: relative;
            display: -ms-flexbox;
            display: flex;
            -ms-flex-direction: column;
            flex-direction: column;
            -ms-flex: 1;
            flex: 1;
            min-height: 0;
            /*margin-bottom: 1.3rem;*/
        }

        .questionBox {
            /*height: 2.5rem;*/
            background: #fff;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;

            .ComposerPC {
                display: -ms-flexbox;
                display: flex;
                -ms-flex-align: end;

                justify-content: space-between;
                padding:.1rem 0;
                align-items: center;

            }

            .inputCls {
                padding: 0 .24rem;
                width:8rem;
                height: 1rem;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                outline: none;
                font-size: .35rem;
                background: #f5f8ff;
                border-radius: .6rem;
                border: .03rem solid rgba(230,233,241,1);
                -webkit-appearance: none;
            }

            .button {
                display: flex;
                justify-content: center;
                align-items: center;
                .sendImg{
                    width: 1rem;
                    height: 1rem;
                }
            }

            .disable {
                background: #f0f2f5;
            }

        }

    }
</style>
